import React from 'react';
import { Star } from '@material-ui/icons';
import './Assets/Styles/ProviderPickStep.css';
import Drawer from '@material-ui/core/Drawer';
import { get, isEmpty, map, size } from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import ProProfileDetails from './ProProfileDetails';

class ProCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.renderTimeButtons = this.renderTimeButtons.bind(this);
  }

  renderTimeButtons() {
    const { therapist, availableTimeSlots, backupRanges, isIC } = this.props;
    const isAlreadyBooked = !isEmpty(get(this.props, 'booking.cart.cartProducts.0.pap_therapist_preferences', []));
    
    // For IC providers with backup ranges, show all available times that fall within their backup ranges
    if (isIC && !isEmpty(backupRanges)) {
      // Extract all backup range start times and convert to 24-hour format for comparison
      const backupTimes = map(backupRanges, (range) => range.start_time);
      const backupTimes24h = map(backupTimes, (time) => moment(time, 'h:mm A').format('HH:mm'));
      
      // Find intersection between backup times (24h format) and available time slots
      const intersectingTimes24h = backupTimes24h.filter((time) => availableTimeSlots.includes(time));
      
      // If there are intersecting times, show all of them sorted by time
      if (!isEmpty(intersectingTimes24h)) {
        // Helper function to convert 24h time string to minutes for comparison
        const timeToMinutes = (timeStr24h) => {
          const [hours, minutes] = timeStr24h.split(':').map(Number);
          return hours * 60 + minutes;
        };
        
        // Sort the intersecting times chronologically
        const sortedIntersectingTimes24h = [...intersectingTimes24h].sort((a, b) => timeToMinutes(a) - timeToMinutes(b));
        
        // Convert 24h times to 12h format for display
        const timesToShow = map(sortedIntersectingTimes24h, (time24h) => moment(time24h, 'HH:mm').format('h:mm A'));
        
        return (
          <div className="d-flex-only flex-wrap" style={{ gap: '8px', maxWidth: '100%' }}>
            {map(timesToShow, (time, idx) => (
              <button
                key={`time-${idx}`}
                type="button"
                disabled={isAlreadyBooked}
                className="btn time-btn-enabled"
                style={{
                  padding: '8px 16px',
                  borderRadius: '36px',
                  backgroundColor: isAlreadyBooked ? '#F6F6F6' : '#F58266',
                  color: isAlreadyBooked ? '#AFAFAF' : '#FFFFFF',
                  border: 'none',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: isAlreadyBooked ? 'not-allowed' : 'pointer',
                  whiteSpace: 'nowrap',
                  flexShrink: 0,
                }}
                onClick={() => {
                  if (!isAlreadyBooked) {
                    // Directly book the provider with the selected time
                    this.props.updateParentState(therapist, time);
                  }
                }}
              >
                {time}
              </button>
            ))}
          </div>
        );
      }
      
      // If no intersection, show all backup times as disabled
      return (
        <div className="d-flex-only flex-wrap" style={{ gap: '8px', maxWidth: '100%' }}>
          {map(backupTimes, (time, idx) => (
            <button
              key={`time-${idx}`}
              type="button"
              disabled
              className="btn time-btn-disabled"
              style={{
                padding: '8px 16px',
                borderRadius: '36px',
                backgroundColor: '#F6F6F6',
                color: '#AFAFAF',
                border: 'none',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'not-allowed',
                whiteSpace: 'nowrap',
                flexShrink: 0,
              }}
            >
              {time}
            </button>
          ))}
        </div>
      );
    }
    
    // For GA providers, don't show time buttons - they will have a Select button instead
    return null;
  }

  render() {
    const { open } = this.state;
    const { therapist, getSelectedTimeSlots, isIC } = this.props;
    const {
      rating, number_of_bookings,
    } = therapist || {};
    const selectedTimeSlots = getSelectedTimeSlots ? getSelectedTimeSlots(therapist.id) : [];
    // For GA providers, check if provider is selected (any entry with this ID)
    // For IC providers, check if they have selected time slots
    const isSelected = isIC ? !isEmpty(get(this.props, 'booking.cart.cartProducts.0.pap_therapist_preferences', []))
      : !isEmpty(selectedTimeSlots);
    
    return (
      <div className="pro-card br-opaque p-16-16-24">
        <Drawer 
          anchor="right" 
          open={open} 
          onClose={() => this.setState({ open: false })}
          PaperProps={{
            style: {
              zIndex: 999999999999,
              width: '471px',
              maxWidth: '100%',
            }
          }}
          ModalProps={{
            style: {
              zIndex: 999999999999,
            }
          }}
        >
          {open ? (
            <ProProfileDetails
              fieldsHolder={this.props.fieldsHolder}
              pro={therapist}
              showProDetailsToggle={() => this.setState({ open: false })}
              selectPro={this.props.updateParentState}
              unselectPro={this.props.removeProFromList}
              time={get(this.props, 'booking.cart.time.display', '')}
              errorHandler={this.props.errorHandler}
              click_source="pick_a_pro"
              selected={isSelected}
              hasMoreThanProSelected={size(selectedTimeSlots) > 1}
              market={get(this.props, 'booking.cart.address.market', '')}
              backupRanges={this.props.backupRanges}
              availableTimeSlots={map(this.props.availableTimeSlots, (time24h) => moment(time24h, 'HH:mm').format('h:mm A'))}
              isIC={isIC}
              booking={this.props.booking}
            />
          ) : null}
        </Drawer>
        <div className="d-flex-only ">
          <div className="pr-8 mb-8">
            <img className="w-h-48 br-rd-50" src={therapist.avatar_url || ''} alt={`${therapist.first_name || ''}-avatar`} />
          </div>
          <div className="mb-8">
            <div className="size-18-24 color-black mb-4 font-weight-bold">
              {therapist.first_name || ''}
              {' '}
              {get(therapist, 'last_name.0', '')}
              . {' '}
              {/* {rating ? ( */}
                <span className="size-14-20 mr-10 mb-4">
                  <span className="contentTertiary">
                    <Star style={{ color: '#F58266' }} />
                    {' '}
                    {rating || ''}
                    {' '}
                    {number_of_bookings ? `(${number_of_bookings})` : 'New'}
                  </span>
                </span>
              {/* ) : null} */}
              {isIC ? <span className="size-12-20 blue-badge mr-8 d-inline-block mb-4">Instant Book</span> : null}
              {/* {!number_of_bookings ? <span className="size-12-20 navy-badge d-inline-block mb-4">New Provider</span> : null} */}
            </div>
          </div>
        </div>
        <div className="size-12-20 contentSecondary min-ht-40 ellipsis-2 mb-8">{therapist.bio || therapist.type || ''}</div>

        {/* Time buttons for IC providers only */}
        {isIC && (
          <div className="mb-8">
            {this.renderTimeButtons()}
          </div>
        )}
        
        {/* Select button for GA providers */}
        {!isIC && (
          <div className="mb-8">
            <button
              type="button"
              className="btn"
              style={{
                padding: '10px 12px',
                borderRadius: '9999px',
                backgroundColor: '#F58266',
                color: '#FFFFFF',
                border: 'none',
                fontSize: '16px',
                fontWeight: '500',
                cursor: 'pointer',
                minWidth: 'auto',
              }}
              onClick={() => {
                const firstAvailableTime = get(this.props, 'availableTimeSlots.0', '');
                if (isSelected) {
                  // Pass the therapist with the first available time slot for proper filtering
                  this.props.removeProFromList({ ...therapist, timeSlot: firstAvailableTime });
                } else {
                  // Pass the first available time slot when selecting
                  this.props.updateParentState(therapist, firstAvailableTime);
                }
              }}
            >
              {isSelected ? '✓ Selected' : 'Select'}
            </button>
          </div>
        )}
        
        <div className="d-flex-only align-items-center" style={{ gap: '4px' }}>
          <div className="size-14-20 contentTertiary" style={{ flex: 1 }}>You won't be charged yet.</div>
          <button
            type="button"
            className="size-14-20"
            style={{
              background: 'none',
              border: 'none',
              color: '#586B94',
              cursor: 'pointer',
              padding: '0',
              fontWeight: '500',
            }}
            onClick={() => {
              this.setState({ open: true });
            }}
          >
            View profile
          </button>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  booking: state.booking,
  fieldsHolder: state.fieldsHolder,
});

export default connect(mapStateToProps, {})(ProCard);
